/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-25 19:58:17
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';

type TableCellProps = {|
  children: any,
  isDragOccurring: boolean,
  className: string
|};

type TableCellSnapshot = {|
  width: number,
  height: number
|};
// DONE
class TableCell extends Component<TableCellProps> {
  ref: ?HTMLElement;

  getSnapshotBeforeUpdate(prevProps: TableCellProps): ?TableCellSnapshot {
    if (!this.ref) {
      return null;
    }

    const isDragStarting: boolean = this.props.isDragOccurring && !prevProps.isDragOccurring;

    if (!isDragStarting) {
      return null;
    }

    const { width, height } = this.ref.getBoundingClientRect();

    const snapshot: TableCellSnapshot = {
      width,
      height
    };
    return snapshot;
  }

  componentDidUpdate(prevProps: TableCellProps, prevState: mixed, snapshot: ?TableCellSnapshot) {
    const ref: ?HTMLElement = this.ref;
    if (!ref) {
      return;
    }

    if (snapshot) {
      if (ref.style.width === snapshot.width) {
        return;
      }
      ref.style.width = `${snapshot.width}px`;
      ref.style.height = `${snapshot.height}px`;
      return;
    }

    if (this.props.isDragOccurring) {
      return;
    }

    // inline styles not applied
    if (ref.style.width == null) {
      return;
    }

    // no snapshot and drag is finished - clear the inline styles
    ref.style.removeProperty('height');
    ref.style.removeProperty('width');
  }

  setRef = (ref: ?HTMLElement) => {
    this.ref = ref;
  };

  render() {
    return (
      <td ref={this.setRef} className={this.props.className}>
        {this.props.children}
      </td>
    );
  }
}

export default TableCell;
